import { render, staticRenderFns } from "./AdditionalInputFee.vue?vue&type=template&id=68f4d93c"
import script from "./AdditionalInputFee.vue?vue&type=script&lang=js"
export * from "./AdditionalInputFee.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInputFee.vue?vue&type=style&index=0&id=68f4d93c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports